export default __webpack_public_path__ + "static/Chalet-NewYorkSixty-6ce7b90487bc77b09f20b9c747c31a1a.woff2";